import { z } from "zod";
import { matchRunFreshnessSchema } from "./twin-matching.js";
/** Unknown source revision metadata remains null; values are still captured exactly. */
export const twinSourceRevisionsSchema = z.object({
    left: z.record(z.string(), z.unknown()),
    right: z.record(z.string(), z.unknown()),
}).strict();
export const twinProposalObservationSchema = z.object({
    id: z.string().min(1),
    proposalId: z.string().min(1),
    batchId: z.string().min(1),
    payload: z.record(z.string(), z.unknown()),
    confidence: z.number().min(0).max(1).nullable(),
    band: z.enum(["automatic", "review", "abstain"]),
    effectClass: z.enum(["reversible", "irreversible"]),
    sourceVersion: z.number().int().positive().nullable(),
    snapshotSha256: z.string().regex(/^[0-9a-f]{64}$/u),
    definition: z.record(z.string(), z.unknown()).nullable(),
    definitionSha256: z.string().regex(/^[0-9a-f]{64}$/u).nullable(),
    sourceRevisions: twinSourceRevisionsSchema.nullable(),
    freshness: matchRunFreshnessSchema.nullable(),
    observedAt: z.number().int().nonnegative(),
}).strict();
